// React
import React from 'react';
import { Button, Modal, ModalHeader, Label, Col, Input } from 'reactstrap';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

export const ModalMarkAsRealized = ({
  isOpen,
  toggle,
  handleBack,
  idRealized,
  updateScheduleRealized,
}) => {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      performedByInput: '',
      hasChangesInput: false,
      historyInput: '',
    },
    validationSchema: Yup.object({
      performedByInput: Yup.string().required(),
      hasChangesInput: Yup.boolean().nullable(),
      historyInput: Yup.string(),
    }),

    onSubmit: (values) => {
      const valuesToSubmit = {
        performed_by: values.performedByInput || null,
        has_changes: values.hasChangesInput,
        history: values.historyInput || null,
      };

      updateScheduleRealized(idRealized, valuesToSubmit);
      toggle();
      validation.resetForm();
    },
  });

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggle();
      }}
      zIndex={10000}
      backdrop={'static'}
      id="staticBackdrop"
      centered
    >
      <ModalHeader>Marcar como Realizado</ModalHeader>
      <div className="modal-body">
        <form
          autoComplete="off"
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit(e);
          }}
        >
          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="performedByInput" className="form-label">
                Visita realizada por
              </Label>
              <Input
                type="text"
                id="performedByInput"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.performedByInput || ''}
                invalid={
                  !!(
                    validation.touched.performedByInput &&
                    validation.errors.performedByInput
                  )
                }
              />
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Input
                id="hasChangesInput"
                className="me-2"
                type="checkbox"
                value={validation.values.hasChangesInput}
                checked={validation.values.hasChangesInput}
                onBlur={validation.handleBlur}
                onChange={(e) => validation.handleChange(e)}
              />
              <Label for="hasChangesInput" className="form-label">
                Houve atualização
              </Label>
            </div>
          </Col>

          <Col md={12}>
            <div className="mb-3">
              <Label htmlFor="historyInput" className="form-label">
                Detalhes da Visita
              </Label>
              <Input
                id="historyInput"
                aria-multiline
                type="textarea"
                className="form-control"
                value={validation.values.historyInput}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                style={{
                  height: 100,
                }}
              />
            </div>
          </Col>
          <div className="text-end">
            <button
              type="button"
              className="btn btn-link"
              onClick={() => {
                handleBack();
                validation.resetForm();
              }}
            >
              Cancelar
            </button>
            <Button color="primary" type="submit">
              Salvar
            </Button>
          </div>
        </form>
      </div>
    </Modal>
  );
};
